function parseOptionalChainId(_env: string | undefined): number {
  return NaN
}

export const BSC_CHAIN_ID = '' as string
export const ETH_CHAIN_ID = '1' as string
export const MATIC_CHAIN_ID = '' as string
export const ARBITRUM_CHAIN_ID = '' as string
export const BASE_CHAIN_ID = '8453' as string

export const ETH_CHAIN_ID_NUMBER = 1
export const BASE_CHAIN_ID_NUMBER = 8453

export const BSC_CHAIN_ID_NUMBER = parseOptionalChainId(undefined)
export const MATIC_CHAIN_ID_NUMBER = parseOptionalChainId(undefined)
export const ARBITRUM_CHAIN_ID_NUMBER = parseOptionalChainId(undefined)
